"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var AffilateOfferEditor = /** @class */ (function (_super) {
    __extends(AffilateOfferEditor, _super);
    function AffilateOfferEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateOfferEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AO = this.props.offersList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_offers: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    offer_id: _item.offer_id,
                    offer_title: _item.offer_title,
                    avail_offers: [],
                    is_deprecated: _item.is_deprecated
                }, function () {
                    _this.loadOffersAvail();
                });
            }
        }
        else {
            this.setState({
                offer_id: 0,
                offer_title: "",
                avail_offers: [],
                is_deprecated: false
            }, function () {
                _this.loadOffersAvail();
            });
        }
        this.doReSetRules();
    };
    AffilateOfferEditor.prototype.loadOffersAvail = function () {
        this.props.offersList.LoadDataByAffilateId(this.props.rootRecord.key);
    };
    AffilateOfferEditor.prototype.componentWillUnmount = function () {
        this.props.offersList.UnSubscribe(this.SID_AO);
    };
    AffilateOfferEditor.prototype.doReSetRules = function () {
        this.setState({
            offer_rules: { isError: false },
        });
    };
    AffilateOfferEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.offer_id <= 0) || (this.state.offer_title.length === 0)) {
            this.setState({ offer_rules: { isError: true, errorMessage: "Оффер не выбран!" } });
            return false;
        }
        return true;
    };
    /*private OnUpdateDataClick() {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                offer_id: this.state.offer_id,
                is_deprecated: this.state.is_deprecated
            }, () => {
                notificationHelper.ShowTextTopRightInfoNotify("Оффер партнерской программы изменен!");
            })
        }
    }*/
    AffilateOfferEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                offer_id: this.state.offer_id,
                affilate_id: this.props.rootRecord.key,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер партнерской программы добавлен!");
            });
        }
    };
    AffilateOfferEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateOfferEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый оффер П.Программы";
        }
        else {
            return "Изменить оффер П.Программы";
        }
    };
    AffilateOfferEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 260 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер:", placeholder: "Выберите оффер" }, value: { key: this.state.offer_id, value: this.state.offer_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        offer_id: newVal.key,
                        offer_title: newVal.value,
                        offer_rules: { isError: false }
                    });
                }, items: this.state.avail_offers, required: true, rules: this.state.offer_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Оффер устарел", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { /*btnEdit: "Сохранить",*/ btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return AffilateOfferEditor;
}(React.Component));
exports.default = AffilateOfferEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/offers/AffilateOfferEditor.tsx
// module id = 2023
// module chunks = 0